import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../SubscriptionDowngrade.module.css';

const PricingTabs = ({ activeTab, handleTabChange, userSubscriptionInterval }) => {
  const { t } = useTranslation();
  
  return (
    <div className={styles.tabContainer}>
      <button
        className={`${styles.tabButton} ${activeTab === 'Annual' ? styles.activeTab : ''}`}
        onClick={() => handleTabChange('Annual')}
      >
        {t('subscription.annual')}
      </button>
      <button
        className={`${styles.tabButton} ${activeTab === 'Monthly' ? styles.activeTab : ''}`}
        onClick={() => handleTabChange('Monthly')}
      >
        {t('subscription.monthly')}
      </button>
    </div>
  );
};

export default PricingTabs; 